import React from 'react';
import {
    Typography,
    Box,
    Chip,
} from '@mui/material';
import { FormFieldType, GetMyInfosQuery } from '@/core/graphql/types';

interface FormFieldValueProps {
    field: GetMyInfosQuery['myInfos']['formSubmissions'][0]['template']['fields'][0];
    value: string;
}

const FormFieldValue: React.FC<FormFieldValueProps> = ({
    field,
    value,
}) => {
    if (!value) {
        return (
            <Typography variant="body2" color="textSecondary" fontStyle="italic">
                -
            </Typography>
        );
    }

    switch (field.type) {
        case FormFieldType.Boolean:
            return (
                <Typography variant="body2">
                    {value === 'true' ? 'Yes' : 'No'}
                </Typography>
            );

        case FormFieldType.Text:
            return (
                <Typography variant="body2">
                    {value}
                </Typography>
            );

        case FormFieldType.Multiple:
            try {
                const values = value.includes('[') ? JSON.parse(value) : [value];
                return (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {values.map((val: string) => (
                            <Chip
                                key={val}
                                label={field.options?.includes(val) ? val : 'Invalid option'}
                                size="small"
                                variant="outlined"
                            />
                        ))}
                    </Box>
                );
            } catch (e) {
                return (
                    <Typography variant="body2" color="error">
                        Invalid multiple choice value
                    </Typography>
                );
            }

        case FormFieldType.Number:
            return (
                <Typography variant="body2">
                    {value}
                </Typography>
            );

        case FormFieldType.TextArea:
            return (
                <Typography
                    variant="body2"
                    sx={{ whiteSpace: 'pre-wrap' }}
                >
                    {value}
                </Typography>
            );

        default:
            return (
                <Typography variant="body2">
                    {value}
                </Typography>
            );
    }
};

export default FormFieldValue; 